import { api } from 'components/api'
import { surveyResponseSubmitPath } from 'components/routes/api'
import {
  toSurveyResponseData,
  toApiSurveyAnswer,
  type ApiSurveyAnswer,
  type ApiSurveyResponseResponse,
  type SurveyAnswer,
  type SurveyResponseData
} from 'components/surveys/responses/services/surveyResponseData'

interface SubmitSurveyResponseParams {
  responseId: number
  answers: SurveyAnswer[]
}

export const submitSurveyResponse = async ({
  responseId,
  answers
}: SubmitSurveyResponseParams): Promise<SurveyResponseData> => {
  const response = await api.postWithCsrf<{ answers: ApiSurveyAnswer[] }, ApiSurveyResponseResponse>({
    url: surveyResponseSubmitPath(responseId),
    headers: { Accept: 'application/json' },
    data: { answers: answers.map(toApiSurveyAnswer) }
  })

  return toSurveyResponseData(response.data)
}
